module.exports = __webpack_public_path__ + "static/media/icon-stamps.10b09706.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/icon-stamps.svg
// module id = 992
// module chunks = 0